import React, { useState, useEffect } from "react";
import { Container, Grid } from "@mui/material";
import api from "../../globals/axios";
import CustomAppBar from "../../components/AppBar";
import { useTranslation } from "react-i18next";
import LoaderContainer from "../../components/LoaderContainer";
import {
  CustomTitle,
  CustomLabel,
} from "../../components/Custom/CustomTypography";
import CustomTabs from "../../components/Custom/CustomTabs";
import ListGenericCard from "../../components/Custom/ListGenericCard";
import { useNavigate } from "react-router-dom";

export default function LoanRequests() {
  const [proposals, setProposals] = useState([]);
  const [loading, setLoading] = useState(true);
  const { t } = useTranslation();
  const searchQuery = "";
  const [selectedTab, setSelectedTab] = useState("pending");
  const navigate = useNavigate();

  const fetchBorrowerList = async (searchQuery) => {
    try {
      const params = { search: searchQuery };
      api
        .get("/lending/loan-request/", {
          params: params,
        })
        .then((response) => {
          setProposals(response.data);
          setLoading(false);
        });
    } catch (error) {
      console.error("Error fetching Borrower list:", error);
      setLoading(false);
    }
  };

  const handleCardClick = (userId, loanId) => {
    navigate(`/lender/requests/${userId}?loanId=${loanId}`);
  };

  useEffect(() => {
    fetchBorrowerList(searchQuery);
  }, [searchQuery]);

  const filteredProposals = proposals.filter(
    (proposal) => proposal.lender_status === selectedTab
  );

  const handleTabChange = (newValue) => {
    let status = "";
    switch (newValue) {
      case 0:
        status = "pending";
        break;
      case 1:
        status = "approved";
        break;
      case 2:
        status = "rejected";
        break;
      default:
        status = "pending";
    }
    setSelectedTab(status);
  };

  return (
    <>
      <CustomAppBar />
      <LoaderContainer loading={loading}>
        <Container maxWidth="xs">
          <Grid container direction="column" alignItems="center">
            <CustomTitle>{t("Loan Request Received")}</CustomTitle>
            <CustomTabs
              numTabs={3}
              tabTitles={[t("Pending"), t("Accepted"), t("Rejected")]}
              counts={[
                proposals.filter(
                  (proposal) => proposal.lender_status === "pending"
                ).length,
                proposals.filter(
                  (proposal) => proposal.lender_status === "approved"
                ).length,
                proposals.filter(
                  (proposal) => proposal.lender_status === "rejected"
                ).length,
              ]}
              onTabChange={handleTabChange}
              tabColors={["#FDF6E0", "#F3FDF3", "#F4DDDD"]}
              tabBordersColor={[
                "1px solid #F8BD00",
                "1px solid #4CAF50",
                "1px solid #CF5C5C",
              ]}
              textColors={["#F8BD00", "#4CAF50", "#CF5C5C"]}
            />
            {filteredProposals.length > 0 ? (
              filteredProposals.map((proposal) => (
                <ListGenericCard
                  key={proposal.id}
                  title={`${proposal?.submit_user?.user?.first_name}`}
                  subtitle={[
                    `${proposal.lender_onboard?.loan_amount} ${proposal.lender_onboard?.loan_tenure_months} ${proposal?.lender_status} `,
                  ]}
                  onClick={() =>
                    handleCardClick(proposal?.submit_user?.id, proposal.id)
                  }
                />
              ))
            ) : (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  textAlign: "center",
                  height: "60vh",
                }}
              >
                <CustomLabel>
                  {t("No loan requests found for")} {selectedTab} {t("status")}
                </CustomLabel>
              </div>
            )}
          </Grid>
        </Container>
      </LoaderContainer>
    </>
  );
}
